import { getAllAgreementTerms } from 'api/agreement-term/agreement-term.api';
import { ListAgreementTermResponse } from 'api/agreement-term/api.types';
import { create } from 'zustand';

interface TermsStore {
  terms: ListAgreementTermResponse[];
  term: ListAgreementTermResponse | null;
  loading: boolean;
  filterStatus: string | null;
  filterCity: string;
  orderBy: 'ASC' | 'DESC';
  totalCount: number;
  take: number;
  page: number;
  setLoading: (loading: boolean) => void;
  setTerms: (terms: ListAgreementTermResponse[]) => void;
  setTerm: (term: ListAgreementTermResponse) => void;
  setFilterStatus: (filterStatus: string | null) => void;
  setFilterCity: (filterCity: string) => void;
  clearFilters: () => void;
  setOrderBy: (orderBy: 'ASC' | 'DESC') => void;
  setTotalCount: (totalCount: number) => void;
  setTake: (take: number) => void;
  setPage: (page: number) => void;
  fetchTerms: () => Promise<void>;
}

const useTermsStore = create<TermsStore>((set, get) => ({
  terms: [],
  term: null,
  loading: false,
  filterStatus: null,
  filterCity: '',
  orderBy: 'DESC',
  totalCount: 0,
  take: 10,
  page: 1,
  setLoading: (loading: boolean) => set({ loading }),
  setTerms: (terms: ListAgreementTermResponse[]) => set({ terms }),
  setTerm: (term: ListAgreementTermResponse) => set({ term }),
  setFilterStatus: (filterStatus: string | null) => set({ filterStatus }),
  setFilterCity: (filterCity: string) => set({ filterCity }),
  clearFilters: () => set({ filterStatus: null, filterCity: '' }),
  setOrderBy: (orderBy: 'ASC' | 'DESC') => set({ orderBy }),
  setTotalCount: (totalCount: number) => set({ totalCount }),
  setTake: (take: number) => set({ take }),
  setPage: (page: number) => set({ page }),
  fetchTerms: async () => {
    set({ loading: true });
    try {
      const response = await getAllAgreementTerms({
        page: String(get().page),
        take: String(get().take),
        orderBy: get().orderBy,
        withDeleted: false,
        status: get().filterStatus ?? undefined,
        city: get().filterCity ?? undefined,
      });

      console.log('response.data on store', response.data);
      set({ terms: response.data });
      set({ totalCount: response.info.count });
    } catch (error) {
      console.error('Erro ao buscar termos de adesão:', error);
    } finally {
      set({ loading: false });
    }
  },
}));

export default useTermsStore;
